export default __webpack_public_path__ + "static/media/WRSBanner.fa40771a.png";